import React from 'react'
import { useNavigate } from 'react-router-dom';

const CreateLiveAccount = () => {
    const navigate = useNavigate();
    const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim()
    return (
        <div className='flex justify-center items-center flex-col h-[calc(100vh-150px)]'>
            <div className='opacity-35 mb-3'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={175} fill={primaryColor}><path d="M346.5 240H272v-74.5c0-8.8-7.2-16-16-16s-16 7.2-16 16V240h-74.5c-8.8 0-16 6-16 16s7.5 16 16 16H240v74.5c0 9.5 7 16 16 16s16-7.2 16-16V272h74.5c8.8 0 16-7.2 16-16s-7.2-16-16-16z" /><path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z" /></svg>
            </div>
            <div className='font-bold text-[#2F2B3D] sm:text-4xl text-xl text-center'>
                You have no live Account
            </div>
            <p className="mt-4 text-center">To get started, you’ll need to create an account.</p>
            <button className='bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover duration-500 mt-5' onClick={() => navigate('/account?type=live')}>Open Live Account</button>
        </div>
    )
}

export default CreateLiveAccount